export var STAR_STATE = {
  EMPTY: 'empty',
  HALF: 'half',
  FULL: 'full'
};
/**
 * Please refer to https://atlas.np.tools.playstation.net/design/6acfb28c-bd35-4f90-b1e0-75fdf8bf00fc/1
 * for the mapping of rating value to visual display of stars
 */

var getStarRatingStarsState = function getStarRatingStarsState(value, maxValue) {
  var configs = Array(maxValue).fill(STAR_STATE.EMPTY);

  if (value > maxValue) {
    // eslint-disable-next-line no-console
    console.warn("Cannot represent rating ".concat(value, " with only ").concat(maxValue, " stars"));
    return configs;
  }

  var end = Math.floor(value);

  for (var i = 0; i < end; i += 1) {
    configs[i] = STAR_STATE.FULL;
  }

  var ratingDecimalPart = value % 1;

  if (ratingDecimalPart !== 0) {
    var roundedDecimalPart = parseFloat(ratingDecimalPart.toFixed(2));

    if (roundedDecimalPart >= 0.25 && roundedDecimalPart < 0.75) {
      configs[end] = STAR_STATE.HALF;
    } else if (roundedDecimalPart >= 0.75) {
      configs[end] = STAR_STATE.FULL;
    }
  }

  return configs;
};

export default getStarRatingStarsState;